export default __webpack_public_path__ + "static/media/464.95d30c81.jpg";